import { useEffect, useState } from 'react';
import useMaps from '../hooks/useMaps';
import { MapView } from './MapView';
import { MapType } from '../CommonTypes';

import { MapSceneSelect } from './MapSceneSelect';

export const MapViewer = ({ maxWidth }: { maxWidth?: string }) => {
  const [currentMap, setCurrentMap] = useState<MapType | null>(null);
  const [maps] = useMaps();

  // Preload all map images once maps are available
  useEffect(() => {
    if (maps && maps.length > 0) {
      // Set first map as default
      setCurrentMap(maps[0]);
    }
  }, [maps]);

  if (!currentMap) return null;

  return (
    <div
      id="pintar-planner-map-wrapper"
      className={`m-auto`}
      style={{ maxWidth: maxWidth ? `clamp(0rem, ${maxWidth}, 90rem)` : '64rem' }}
    >
      <div className={`pintar-planner-content-wrapper relative`}>
        <MapView map={currentMap} setCurrentMap={setCurrentMap} />
        <MapSceneSelect currentScene={currentMap} setSelectedScene={setCurrentMap} />
      </div>
    </div>
  );
};
